import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ExcepcionGMFDestino } from '../_models/excepcion-gmf-destino';

@Injectable({
  providedIn: 'root'
})
export class ExcepcionGMFDestinoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/excepcionesGMFDestinos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ExcepcionGMFDestino [] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ExcepcionGMFDestino [] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ExcepcionGMFDestino ) );
  }

  crear( regCrear: ExcepcionGMFDestino ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ExcepcionGMFDestino ) );
  }

  actualizar( regActualizar: ExcepcionGMFDestino ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as ExcepcionGMFDestino ) );
  }

  obtenerPorIdExcepcionGMF( id: string ) {
    return this.httClient.get( this.rutServicio + '/excepcion/' + id ).pipe( map( res => res as ExcepcionGMFDestino [] ) );
  }

}
